import { getFolderResourceItems, resourceFolderFileUrl } from './folderResources';

const SEGMENT = 'parents';

/** Files in public/resources/parents/ - add one row per file. */
export const PARENT_RESOURCE_FILES = [
  {
    id: 'digital-canadian-families',
    title: 'Digital Canadian families',
    description: 'Resource for parents and guardians on digital life and Canadian families.',
    filename: 'digital-canadian-families.pdf',
    icon: '📄',
  },
  {
    id: 'effective-methods-stem-pathways',
    title: 'Effective methods: information on STEM education pathways',
    description: 'Guidance for families on STEM pathways and how to support learners.',
    filename: 'Effective-methods-information-STEM-education-pathways (3).pdf',
    icon: '📄',
  },
  {
    id: 'why-stem-parents-guardians',
    title: 'Why STEM - for parents and guardians',
    description: 'Overview of why STEM matters and how parents can encourage participation.',
    filename: 'Why-STEM-For-Parents-and-Guardians.pdf',
    icon: '📄',
  },
  {
    id: 'wia-part-5-final',
    title: 'WIA - Part 5 (final)',
    description: 'Parent-facing resource (Part 5, final version).',
    filename: 'WIA-Part-5-FINAL.pdf',
    icon: '📄',
  },
];

export function parentResourceFileUrl(filename) {
  return resourceFolderFileUrl(SEGMENT, filename);
}

export function getParentResourceItems() {
  return getFolderResourceItems(SEGMENT, PARENT_RESOURCE_FILES);
}
